export default __webpack_public_path__ + "static/media/piggy.479b1da6.png";